(function ($, document, window, undefined) {
    'use strict';
    $(function () {
        $('.btn_menu').on('click', function () {
            if ($('.menu_sidebar').hasClass('d-none')) {
                $('.menu_sidebar').removeClass('d-none');
            } else {
                $('.menu_sidebar').addClass('d-none');
            }
        })

        // 仰角のラジオボタン選択
        $('.list_icon .link_bevel').each(function () {
            let $this = $(this);

            $this.on('click', function () {
                let $input = $this.find('.radio_icon_bevel');

                if ($input.hasClass('bevel_1')) {
                    $input.prop("checked", true);
                    $this.find('.no_color_bevel_1').addClass('d-none');
                    $this.find('.bevel_color_1').removeClass('d-none');

                    if ($('.no_color_bevel_2').hasClass('d-none')) {
                        $('.no_color_bevel_2').removeClass('d-none');
                        $('.bevel_color_2').addClass('d-none');
                    }
                    if ($('.no_color_bevel_3').hasClass('d-none')) {
                        $('.no_color_bevel_3').removeClass('d-none');
                        $('.bevel_color_3').addClass('d-none');
                    }

                    if ($('.no_color_bevel_4').hasClass('d-none')) {
                        $('.no_color_bevel_4').removeClass('d-none');
                        $('.bevel_color_4').addClass('d-none');
                    }
                    if ($('.no_color_bevel_5').hasClass('d-none')) {
                        $('.no_color_bevel_5').removeClass('d-none');
                        $('.bevel_color_5').addClass('d-none');
                    }

                } else if ($input.hasClass('bevel_2')) {
                    $input.prop("checked", true);
                    $this.find('.no_color_bevel_2').addClass('d-none');
                    $this.find('.bevel_color_2').removeClass('d-none');

                    if ($('.no_color_bevel_1').hasClass('d-none')) {
                        $('.no_color_bevel_1').removeClass('d-none');
                        $('.bevel_color_1').addClass('d-none');
                    }
                    if ($('.no_color_bevel_3').hasClass('d-none')) {
                        $('.no_color_bevel_3').removeClass('d-none');
                        $('.bevel_color_3').addClass('d-none');
                    }

                    if ($('.no_color_bevel_4').hasClass('d-none')) {
                        $('.no_color_bevel_4').removeClass('d-none');
                        $('.bevel_color_4').addClass('d-none');
                    }
                    if ($('.no_color_bevel_5').hasClass('d-none')) {
                        $('.no_color_bevel_5').removeClass('d-none');
                        $('.bevel_color_5').addClass('d-none');
                    }
                } else if ($input.hasClass('bevel_3')) {
                    $input.prop("checked", true);
                    $this.find('.no_color_bevel_3').addClass('d-none');
                    $this.find('.bevel_color_3').removeClass('d-none');

                    if ($('.no_color_bevel_1').hasClass('d-none')) {
                        $('.no_color_bevel_1').removeClass('d-none');
                        $('.bevel_color_1').addClass('d-none');
                    }
                    if ($('.no_color_bevel_2').hasClass('d-none')) {
                        $('.no_color_bevel_2').removeClass('d-none');
                        $('.bevel_color_2').addClass('d-none');
                    }

                    if ($('.no_color_bevel_4').hasClass('d-none')) {
                        $('.no_color_bevel_4').removeClass('d-none');
                        $('.bevel_color_4').addClass('d-none');
                    }
                    if ($('.no_color_bevel_5').hasClass('d-none')) {
                        $('.no_color_bevel_5').removeClass('d-none');
                        $('.bevel_color_5').addClass('d-none');
                    }
                } else if ($input.hasClass('bevel_4')) {
                    $input.prop("checked", true);
                    $this.find('.no_color_bevel_4').addClass('d-none');
                    $this.find('.bevel_color_4').removeClass('d-none');

                    if ($('.no_color_bevel_1').hasClass('d-none')) {
                        $('.no_color_bevel_1').removeClass('d-none');
                        $('.bevel_color_1').addClass('d-none');
                    }
                    if ($('.no_color_bevel_2').hasClass('d-none')) {
                        $('.no_color_bevel_2').removeClass('d-none');
                        $('.bevel_color_2').addClass('d-none');
                    }

                    if ($('.no_color_bevel_3').hasClass('d-none')) {
                        $('.no_color_bevel_3').removeClass('d-none');
                        $('.bevel_color_3').addClass('d-none');
                    }
                    if ($('.no_color_bevel_5').hasClass('d-none')) {
                        $('.no_color_bevel_5').removeClass('d-none');
                        $('.bevel_color_5').addClass('d-none');
                    }
                } else if ($input.hasClass('bevel_5')) {
                    $input.prop("checked", true);
                    $this.find('.no_color_bevel_5').addClass('d-none');
                    $this.find('.bevel_color_5').removeClass('d-none');

                    if ($('.no_color_bevel_1').hasClass('d-none')) {
                        $('.no_color_bevel_1').removeClass('d-none');
                        $('.bevel_color_1').addClass('d-none');
                    }
                    if ($('.no_color_bevel_2').hasClass('d-none')) {
                        $('.no_color_bevel_2').removeClass('d-none');
                        $('.bevel_color_2').addClass('d-none');
                    }

                    if ($('.no_color_bevel_3').hasClass('d-none')) {
                        $('.no_color_bevel_3').removeClass('d-none');
                        $('.bevel_color_3').addClass('d-none');
                    }
                    if ($('.no_color_bevel_4').hasClass('d-none')) {
                        $('.no_color_bevel_4').removeClass('d-none');
                        $('.bevel_color_4').addClass('d-none');
                    }
                }
            })
        });

        // 画角のラジオボタン選択
        $('.list_icon .link_view').each(function () {
            let $this = $(this);

            $this.on('click', function () {
                let $input = $this.find('.radio_icon_view');

                if ($input.hasClass('view_1')) {
                    $input.prop("checked", true);
                    $this.find('.no_color_view_1').addClass('d-none');
                    $this.find('.view_color_1').removeClass('d-none');

                    if ($('.no_color_view_2').hasClass('d-none')) {
                        $('.no_color_view_2').removeClass('d-none');
                        $('.view_color_2').addClass('d-none');
                    }
                    if ($('.no_color_view_3').hasClass('d-none')) {
                        $('.no_color_view_3').removeClass('d-none');
                        $('.view_color_3').addClass('d-none');
                    }

                    if ($('.no_color_view_4').hasClass('d-none')) {
                        $('.no_color_view_4').removeClass('d-none');
                        $('.view_color_4').addClass('d-none');
                    }
                    if ($('.no_color_view_5').hasClass('d-none')) {
                        $('.no_color_view_5').removeClass('d-none');
                        $('.view_color_5').addClass('d-none');
                    }
                } else if ($input.hasClass('view_2')) {
                    $input.prop("checked", true);
                    $this.find('.no_color_view_2').addClass('d-none');
                    $this.find('.view_color_2').removeClass('d-none');

                    if ($('.no_color_view_1').hasClass('d-none')) {
                        $('.no_color_view_1').removeClass('d-none');
                        $('.view_color_1').addClass('d-none');
                    }
                    if ($('.no_color_view_3').hasClass('d-none')) {
                        $('.no_color_view_3').removeClass('d-none');
                        $('.view_color_3').addClass('d-none');
                    }

                    if ($('.no_color_view_4').hasClass('d-none')) {
                        $('.no_color_view_4').removeClass('d-none');
                        $('.view_color_4').addClass('d-none');
                    }
                    if ($('.no_color_view_5').hasClass('d-none')) {
                        $('.no_color_view_5').removeClass('d-none');
                        $('.view_color_5').addClass('d-none');
                    }
                } else if ($input.hasClass('view_3')) {
                    $input.prop("checked", true);
                    $this.find('.no_color_view_3').addClass('d-none');
                    $this.find('.view_color_3').removeClass('d-none');

                    if ($('.no_color_view_1').hasClass('d-none')) {
                        $('.no_color_view_1').removeClass('d-none');
                        $('.view_color_1').addClass('d-none');
                    }
                    if ($('.no_color_view_2').hasClass('d-none')) {
                        $('.no_color_view_2').removeClass('d-none');
                        $('.view_color_2').addClass('d-none');
                    }

                    if ($('.no_color_view_4').hasClass('d-none')) {
                        $('.no_color_view_4').removeClass('d-none');
                        $('.view_color_4').addClass('d-none');
                    }
                    if ($('.no_color_view_5').hasClass('d-none')) {
                        $('.no_color_view_5').removeClass('d-none');
                        $('.view_color_5').addClass('d-none');
                    }
                } else if ($input.hasClass('view_4')) {
                    $input.prop("checked", true);
                    $this.find('.no_color_view_4').addClass('d-none');
                    $this.find('.view_color_4').removeClass('d-none');

                    if ($('.no_color_view_1').hasClass('d-none')) {
                        $('.no_color_view_1').removeClass('d-none');
                        $('.view_color_1').addClass('d-none');
                    }
                    if ($('.no_color_view_2').hasClass('d-none')) {
                        $('.no_color_view_2').removeClass('d-none');
                        $('.view_color_2').addClass('d-none');
                    }

                    if ($('.no_color_view_3').hasClass('d-none')) {
                        $('.no_color_view_3').removeClass('d-none');
                        $('.view_color_3').addClass('d-none');
                    }
                    if ($('.no_color_view_5').hasClass('d-none')) {
                        $('.no_color_view_5').removeClass('d-none');
                        $('.view_color_5').addClass('d-none');
                    }
                } else if ($input.hasClass('view_5')) {
                    $input.prop("checked", true);
                    $this.find('.no_color_view_5').addClass('d-none');
                    $this.find('.view_color_5').removeClass('d-none');

                    if ($('.no_color_view_1').hasClass('d-none')) {
                        $('.no_color_view_1').removeClass('d-none');
                        $('.view_color_1').addClass('d-none');
                    }
                    if ($('.no_color_view_2').hasClass('d-none')) {
                        $('.no_color_view_2').removeClass('d-none');
                        $('.view_color_2').addClass('d-none');
                    }

                    if ($('.no_color_view_3').hasClass('d-none')) {
                        $('.no_color_view_3').removeClass('d-none');
                        $('.view_color_3').addClass('d-none');
                    }
                    if ($('.no_color_view_4').hasClass('d-none')) {
                        $('.no_color_view_4').removeClass('d-none');
                        $('.view_color_4').addClass('d-none');
                    }
                }
            })
        });



        // スライダー操作
        $('.list_checkbox_superposition').each(function () {
            let $this = $(this);
            let $form = $this.find('.form_check_input');
            let $range = $this.find('.range_list');

            $form.on('click', function () {
                if ($form.is(':checked')) {
                    $range.removeClass('d-none');
                } else {
                    $range.addClass('d-none');
                }
            });
        })

        $('.range_list').each(function () {
            let $this = $(this);
            let $range = $this.find('.range_sliders');
            let $value = $this.find('.value_range');

            $this.on('input', $range, function () {
                $value.val($range.val() + '%');
            })
        })

        // 画像選択
        $(".onClickHandler").on("click", function (e) {
        });

        $(".onClickHandler").on("change", function (e) {
            let files = e.target.files;
            let d = new $.Deferred().resolve();
            $.each(files, function (i, file) {
                d = d.then(function () {
                    return previewImage(file);
                });
            });
        });

        // 選択画像のプレビュー表示
        let previewImage = function (imageFile) {
            let reader = new FileReader();
            let img = new Image();
            let def = $.Deferred();
            reader.onload = function (e) {
                // 画像を表示
                //$(".img_preview").empty();
                //$(".img_preview").append(img);
                //img.src = e.target.result;
                //def.resolve(img);]
                document.getElementById('preview_images').src = e.target.result;
                document.getElementById('preview_images').classList.remove('d-none');
                document.getElementById('no_image_preview').className += " d-none";

            };
            reader.readAsDataURL(imageFile);
            exifGet(imageFile);

            return def.promise();
        };

         // exif情報の取得
         let exifGet = function (file) {
            new Promise((resolve, reject) => {
                EXIF.getData(file, function () {
                    let allMetaData = EXIF.getAllTags(this);
                    let allMetaDataSpan = document.getElementById("allMetaDataSpan");
                    allMetaDataSpan.innerHTML = JSON.stringify(allMetaData, null, "\t");
                  
                    // resolve();
                    let req = {
                        DateTimeOriginal:allMetaData.DateTimeOriginal,
                        GPSLatitudeRef:allMetaData.GPSLatitudeRef,
                        GPSLatitude:allMetaData.GPSLatitude,
                        GPSLongitudeRef:allMetaData.GPSLongitudeRef,
                        GPSLongitude:allMetaData.GPSLongitude,
                        FocalLengthIn35mmFilm:allMetaData.FocalLengthIn35mmFilm,
                        GPSAltitudeRef:allMetaData.GPSAltitudeRef,
                        GPSAltitude:allMetaData.GPSAltitude,
                        GPSImgDirectionRef:allMetaData.GPSImgDirectionRef,
                        GPSImgDirection:allMetaData.GPSImgDirection,
                        CameraElevationAngle:allMetaData.CameraElevationAngle,
                    }
                    let path = location.pathname;
                    $.ajax({
                        url: path ,
                        type: "GET",
                        data: {content : req},
                        datatype: "html",
                        success: function(data){
                          //成功時の処理
                        },
                        error: function(data){
                          //失敗時の処理
                        }
                      });
                    //取得したimgFile.exifdata.Orientationに対し、function内で処理を進めることも可能
                });
                // }),then(() => {
            });
        };

        // 画像アップロード記事の削除機能
        $('.btn_delete_image').on('click', function () {
            document.getElementById('preview_images').src = null;
            $('input[type=file]').val('');
            $('#preview_images.img_bg_upload').addClass('d-none');
            $('#no_image_preview.img_bg_upload').removeClass('d-none');
        });

        // Function Open Modal Post Page
        $('.btn_shooting_post').on('click', function () {
            $('#btn_search_map').addClass('show').css('display', 'block');
            $('body').addClass('modal-open').css('padding-right', '15px');
            $('.modal-backdrop').addClass('show').removeClass('d-none');
        });
        $('#btn_search_map .btn_popup_modal_2').on('click', function () {
            $('#btn_search_map').removeClass('show').css('display', '');
            $('#btn_search_map2').addClass('show').css('display', 'block');
        });
        $('#btn_search_map2 .btn_popup_hide').on('click', function () {
            $('#btn_search_map2').removeClass('show').css('display', '');
            $('body').removeClass('modal-open').css('padding-right', '');
            $('.modal-backdrop').removeClass('show').addClass('d-none');
        });

        // Tab Search Map
        $('.tab_search_content').each(function () {
            let $this = $(this);
            let $list_tab_map = $this.find('.list_status li.tab_public');
            let $list_tab_search = $this.find('.list_status li.tab_private');
            let $tab_search_map = $this.find('.tab_search_map');
            let $tab_search_detail = $this.find('.tab_search_detail');

            $list_tab_map.on('click', function () {
                $list_tab_map.addClass('active');
                $list_tab_search.removeClass('active');

                $tab_search_map.removeClass('d-none');
                $tab_search_detail.addClass('d-none');
            });

            $list_tab_search.on('click', function () {
                $list_tab_map.removeClass('active');
                $list_tab_search.addClass('active');

                $tab_search_detail.removeClass('d-none');
                $tab_search_map.addClass('d-none');
            });

        });

    });
}(jQuery, document, window));